import React, { useState, useEffect, useContext } from "react";
import {
  Row,
  Col,
  Card,
  Divider,
  message,
  Typography,
  List,
  Badge,
  Checkbox,
  Tooltip,
  Button,
  Space,
  Segmented,
} from "antd";
import { MessageOutlined, BellOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { HeaderTitle } from "../../components/headerTitle";
import { useNavigate } from "react-router-dom";
import { HeaderPage } from "../../components/headerPage";
import { ItemList } from "../../components/itemList";
import { formatDate } from "../../helpers/formatDate";
import { listarPendencias } from "../../helpers/pendencias";
import { AuthContext } from "../../contexts/AuthContext";

import http from "../../services/http";
const { Text, Paragraph } = Typography;

// OPTIONS FILTRO
const options_filtro = [
  { label: "Todos", value: 999 },
  { label: "Não Lidos", value: 0 },
  { label: "Lidos", value: 1 },
];

export const Notificacoes = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState();
  const { atualizarPendencias } = useContext(AuthContext);

  // DADOS
  const [dados, setDados] = useState([]);
  const [filtro, setFiltro] = useState(999);

  useEffect(() => {
    carregarNotificacoes();
  }, []);

  // CARREGAR NOTIFICAÇÕES
  const carregarNotificacoes = async () => {
    setLoading(true);
    const api = await http("get", `v1/notificacoes/listar_visualizacao`, []);
    if (api.statusCode === 200) {
      setDados(api.response.data);

      // ATUALIZAR PENDÊNCIAS
      listarPendencias(atualizarPendencias);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // ALTERAR LOG NOTIFICAÇÕES
  const alterarLogNotificacoes = async (value, id_colaborador, id_cad_notificacoes) => {
    setLoading(true);
    const form = {
      status: value ? 1 : 0,
      id_colaborador: id_colaborador,
      id_cad_notificacoes: id_cad_notificacoes,
    };
    const api = await http("post", `v1/notificacoes_log/alterar`, form);
    if (api.statusCode === 200) {
      carregarNotificacoes();
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // ALTERAR LOG TODAS NOTIFICAÇÕES
  const alterarTodosLogNotificacoes = async () => {
    const api = await http("post", `v1/notificacoes_log/alterar_todos`);
    if (api.statusCode === 200) {
      carregarNotificacoes();
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  const renderList = (item) => {
    return (
      <List.Item key={item.id} style={{ paddingBlock: 5 }}>
        <Badge.Ribbon
          text={<InfoCircleOutlined style={{ fontSize: 12 }} />}
          className={item.status === 1 ? "none" : "block"}
          placement="start"
          color="orange">
          <ItemList
            leftComponent={
              <div className="item-collapse-icon" style={item.tipo === 1 ? { backgroundColor: "#2194f245" } : {}}>
                {item.tipo === 1 ? (
                  <BellOutlined style={{ fontSize: 22, color: "#2194f2" }} />
                ) : (
                  <MessageOutlined style={{ fontSize: 22, color: "#60b565" }} />
                )}
              </div>
            }
            onClick={() => item.link_web && navigate(item.link_web)}
            hoverable={item.link_web ? true : false}
            rightComponent={
              <Tooltip title="Marcar como lido">
                <Checkbox
                  checked={item.status === 1 ? true : false}
                  onClick={(e) => {
                    e.stopPropagation();
                    alterarLogNotificacoes(item.status === 1 ? false : true, item.id_colaborador, item.id);
                  }}
                />
              </Tooltip>
            }>
            <Space wrap size={10}>
              <Text strong>{item.descricao}</Text>
              <Text type="secondary" style={{ fontSize: 12 }}>
                {formatDate(item.data_envio)}
              </Text>
            </Space>
            <Paragraph style={{ margin: 0 }}>
              <div dangerouslySetInnerHTML={{ __html: item.obs }} />
            </Paragraph>
          </ItemList>
        </Badge.Ribbon>
      </List.Item>
    );
  };

  // PESQUISAR
  const handleFilter = (marcado) => {
    let filteredData = dados;
    if (marcado !== 999) {
      filteredData = filteredData.filter((e) => {
        return e.status === marcado;
      });
    }
    return filteredData;
  };

  const dadosFilter = dados?.length > 0 ? handleFilter(filtro) : [];

  return (
    <Row align="middle" justify="center" className="content-row">
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={20} xl={20} xxl={14} align="left" className="content-item">
          <HeaderPage title="Configurações" onClickBack={() => navigate("/perfil")} />
          <HeaderTitle
            title="Notificações"
            subtitle="Consultar minhas notificações."
            icon={<BellOutlined />}
            loading={loading}
          />
          <Divider />

          <Card bordered={false} bodyStyle={{ padding: "3%" }}>
            <List
              itemLayout="vertical"
              style={{ width: "100%" }}
              loading={loading}
              header={
                <Space wrap>
                  <Segmented value={filtro} onChange={(e) => setFiltro(e)} options={options_filtro} />

                  <Button disabled={loading} type="link" onClick={alterarTodosLogNotificacoes}>
                    Marcar todas como lidas
                  </Button>
                </Space>
              }
              split={false}
              pagination
              dataSource={dadosFilter}
              renderItem={renderList}
            />
          </Card>
        </Col>
      </Col>
    </Row>
  );
};
